// import CartIcon from '@/_assets/icon-components/Cart';
import cartIcon from '@/shared/assets/svg/cart-bold-grey.svg';
import { HeartIcon } from 'lucide-react';
import Image from 'next/image';

export const userOptions = [
  // {
  //   icon: <UserIcon color='var(--text-muted)' />,
  //   label: 'profile',
  //   link: '/profile',
  // },
  {
    icon: <Image src={cartIcon} alt='cart' width={20} height={20} />,
    label: 'my_orders',
    link: '/orders',
  },
  {
    // icon: <CoinsIcon color='var(--text-muted)' size={20} />,
    icon: <HeartIcon color='var(--text-muted)' size={20} />,
    label: 'loyalty_program',
    link: '/loyalty',
  },
] as const;
